import { Component, OnInit } from '@angular/core';
import { StatementsFacade } from '@app/modules/businesses/services/statements.facade';
import { Observable } from 'rxjs';
import { Adjustment, AdjustmentsState } from '@app/modules/businesses/models/statements.models';
import { BehaviorSubject } from 'rxjs';
import { Filter } from '@app/shared/models/filter';
import { OnDestroyComponent } from '@app/shared/components/on-destroy/on-destroy.component';
import { takeUntil, filter, map, switchMap, distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * TODO:
 * - Add the ability to go to "next" or "previous" adjustment
 */

@Component({
  selector: 'sbnb-adjustments',
  templateUrl: './adjustments.component.html',
})
export class AdjustmentsComponent extends OnDestroyComponent implements OnInit {
  public state$: Observable<AdjustmentsState> = this.statementsFacade.adjustmentsState$;
  public activeFilters$: BehaviorSubject<Filter[]> = new BehaviorSubject<Filter[]>([]);
  public previewedAdjustment$ = this.route.queryParams.pipe(
    map((params) => params['adjustmentUuid']),
    distinctUntilChanged(),
    switchMap((adjustmentUuid) =>
      this.state$.pipe(
        filter((state) => !!state.data),
        map((state) => state.data.find((a) => a.uuid === adjustmentUuid) ?? null)
      )
    ),
    takeUntil(this.destroyed$)
  );

  constructor(
    private statementsFacade: StatementsFacade,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();

    this.activeFilters$.pipe(takeUntil(this.destroyed$)).subscribe((filters) => {
      this.statementsFacade.getAdjustments(filters);
    });
  }

  ngOnInit(): void {
    this.statementsFacade.getAdjustments();
  }

  onPageChange(page: number): void {
    this.statementsFacade.getAdjustments(this.activeFilters$.value, page);
  }

  onAdjustmentSelected(adjustmentUuid: Adjustment['uuid'] | null): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { adjustmentUuid: adjustmentUuid || null },
      queryParamsHandling: 'merge',
    });
  }

  onAdjustmentApplied(): void {
    this.statementsFacade.getAdjustments(this.activeFilters$.value);
  }
}
